import { useAuth } from './useAuth'

/**
 * Legacy admin authentication hook for backward compatibility
 *
 * This hook is now a thin wrapper around useAuth() that provides
 * the same interface as before. All new code should use useAuth()
 * directly for multi-role support.
 *
 * @deprecated Use useAuth() instead for multi-role support
 * @example
 * ```tsx
 * // Old way (still works):
 * const { isAdmin, isLoading, user } = useAdminAuth()
 *
 * // New way (recommended):
 * const { user, role, isAdmin, isPartner, loading } = useAuth()
 * ```
 */
export function useAdminAuth() {
  const { user, isAdmin: checkIsAdmin, loading } = useAuth()

  return {
    isAdmin: checkIsAdmin(),
    isLoading: loading,
    user,
  }
}

// Hook for checking admin permissions
export function useAdminPermissions() {
  const { isAdmin } = useAdminAuth();

  const hasPermission = (_permission: string): boolean => {
    // For now, all admin users have all permissions
    // In the future, this can be expanded to check specific permissions
    return isAdmin;
  };

  return {
    hasPermission,
  };
}
